module.exports = __webpack_public_path__ + "static/opacity-76fbe0a654aace5a193b91c02ac8adc2.jpg";